
const appConstant = {
    TOKEN: ".token",
    TOKENS: ".tokens",
    PROFILE: ".profile",
    COMPANIES: ".companies",
    COMPANY: ".company",
    nameIdentifierClaim: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier",
    nameClaim: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name",
    givenNameClaim: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname",
    roleClaim: 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
    expire: '.expires',
    displayFields: 'displayFields',
    filterFields: 'filterFields',
    operators: 'operators',
    clientFilters: '.clientFilters',
    salesRep: '.salesRep',
    negotiators: '.negotiators',
    loanStatus: '.loanStatus',
    clientId: '.clientId',
    clientDetail: '.clientDetail',
    permissionDetail: ".permissionDetail",
    COMPANIES_CODES: [{ name: 'JW Financial', code: 'JWF' }, { name: 'Legal Admin Center', code: 'LAC' }],
    affiliates: '.affiliates',
    languages: '.languages',
    titles: '.titles',
    genders: '.genders',
    states: '.states',
    clientCareTemplates: ".clientcaretemplates",
    lendertiers: ".lendertiers",
    debtType: ".debtType",
    attorneys: ".attorneys",
    renewalfrequency: ".renewalfrequency",
    notestemplates: ".notestemplates",
    includeAffilaite: ".includeAffilaite",
    paymentStatus: ".paymentStatus",
    customerRep: ".customerRep",
    all_users_except_me: ".all_users_except_me",
    companyTags: ".companyTags",
    leadsearch: ".leadsearch",
    clientSearch: ".clientSearch",
    incomeType: '.incomeType',
    expenseType: '.expenseType',
    senderPhones: 'senderPhones',
    communicationPreferences: '.communication_preference',
    clientRedirectUrl: "/admin/client/profile/detail",
    dmClientRedirectUrl: "/admin/client/profile/dm_view",
    clientHistoryUrl: "/admin/client/history/audit",
    paymentRedirectUrl: "/admin/client/program/draft/calculator",
    isPayment: ".ispayment",
    teams: ".teams",
    answerTypes: ".answerTypes",
    typeAnswers: ".typeAnswers",
    hardShipTypes: ".hardShipTypes",
    signalREvents: ['calendarNotify', 'calendarReminderNotify', 'ticketAddNotify', 'ticketUpdateNotify', 'ticketResolvedNotify', 'ticketClosedNotify',
    'ticketNoteAddNotify','pushNotificationNotify','newLeadAddedNotify','calendarDispositionNotify','realTimeNotificationNotify'],
    signatureRequestMode:".signatureRequestMode",
    CompanyCode:".CompanyCode",
    adminClientRedirect:"/admin/redirect",
    ticketUsers:".ticketUsers",
    ticketTeams:".ticketTeams",
    purchasersStatus:".purchasersStatus",
    issued:".issued"
};

export default appConstant